import { Link } from 'react-router-dom';
import './public.css';

/** Server-rendered with HTTP 404 for every unknown URL (also nginx-level 404s are proxied here). */
export default function NotFoundPage() {
  return <section className="catalog-hero not-found"><div className="container">
    <p className="eyebrow">Ошибка 404</p>
    <h1>Кажется, мы свернули не туда</h1>
    <p className="hero-copy">Такой страницы нет: ссылка устарела или в адресе опечатка. Трамваи ходят по расписанию — а мы поможем вернуться на маршрут.</p>
    <div className="hero-actions">
      <Link className="button button--primary" to="/">На главную</Link>
      <Link className="button button--ghost" to="/excursions/kttu">Экскурсии КТТУ</Link>
      <Link className="button button--ghost" to="/excursions/botanicheskaya-progulka">Ботаническая прогулка</Link>
      <Link className="button button--ghost" to="/shkolam">Школам</Link>
    </div>
  </div></section>;
}
